import React from 'react'

import Navbar from './Home/Navbar'
import Hero from './About/Hero'
import Footer from './Home/Footer'
import Details from './About/Details'
export default function About() {
  return (
    <div className='w-full overflow-hidden'>
            <Navbar/>
            <Hero/>
            <Details/>
            <Footer/>
          </div>
  )
}
